import { Language } from './language';

const fr = {
    code: Language.fr,

	// HOME PAGE
	
	t_description: 'Fille batteuse de {age} ans',
	t_close: 'Fermer',

	b_home: 'Accueil',
	b_about: 'Sur moi',
	b_press: 'Presse et Médias',
	b_shows: 'Performances en direct',
	b_latest_show: 'Récent',
	b_soultone: 'Soultone',
	b_paiste: 'Paiste',
	b_collision: 'Collision',
	b_language: 'Français',
	b_share: 'Partager',
	b_scroll_to_top: 'Faites défiler vers le haut',
	b_click: 'Cliquez',
	b_tap: 'Appuyer',
	
	t_english: 'Anglaise',
	t_spanish: 'Espagnole',
	t_portuguese: 'Portugais',
	t_italian: 'Italien',
	t_french: 'Français',
	t_german: 'Allemand',
	t_chinese: 'Chinois',

	// SHOWS PAGE

	KRKComeTogether2026DROM_title: 'Festival KRFK Come Together',
	KRKComeTogether2026DROM_description: 'DROM, New York',

	KRKComeTogether2026Chelsea_title: 'Festival KRFK Come Together',
	KRKComeTogether2026Chelsea_description: 'Chelsea Table & Stage, New York',

	RockFantasy2026Whisky_title: 'Camp Fantasy du Rock and Roll',
	RockFantasy2026Whisky_description: 'The Whisky a Go Go, Hollywood CA.',

	RockFantasy2026Viper_title: 'Camp Fantasy du Rock and Roll',
	RockFantasy2026Viper_description: 'The Viper Room, Hollywood CA.',

	FulcrumCelebrationOfLight2026_title: 'Célébration de la Lumière de Fulcrum',
	FulcrumCelebrationOfLight2026_description: 'Sheraton Grand Seattle',

	QueenTribute_title: 'Hommage à Queen',
	QueenTribute_description: 'School of Rock Seattle',
	
	FremontFridays2025_title: 'Les vendredis de Fremont 2025',
	FremontFridays2025_description: 'Les vendredis de Fremont à Seattle',

	DrumFantasyCamp2025_title: 'Camp Drum Fantasy 2025',
	DrumFantasyCamp2025_description: 'Camp Drum Fantasy à Los Angeles',

	ClassicMetal_title: 'Métal classique',
	ClassicMetal_description: 'School of Rock Seattle',

	StAlsGrandDay2024_title: 'Performance du Grand Jour 2024',
	StAlsGrandDay2024_description: 'St. Alphonsus Parish School Seattle',

	BlackViolinConcert_title: 'Concert De Violon Noir Avec Le Monde Votre Orchestre',
	BlackViolinConcert_description: 'Le Théâtre Paramount',

	MexicanIndependenceDay2024_title: 'Célébration du Jour de l\'Indépendance du Mexique avec le Ballard Civic Orchestra',
	MexicanIndependenceDay2024_description: 'Hôtel de ville de Seattle',

	BluesRock_title: 'Blues Rock',
	BluesRock_description: 'School of Rock Seattle',

	BallardSeaFoodFest2024_title: 'Festival des fruits de mer Ballard 2024',
	BallardSeaFoodFest2024_description: 'Festival des fruits de mer Ballard',

	Funk_title: 'Funk',
	Funk_description: 'School of Rock Seattle',

	Heart_title: 'Heart',
	Heart_description: 'School of Rock Seattle',
	
	ModernMetal_title: 'Métal moderne',
	ModernMetal_description: 'School of Rock Seattle',

	SeasonPreviewWinter2023_title: 'Aperçu de la saison hiver 2023',
	SeasonPreviewWinter2023_description: 'School of Rock Seattle',

	SmashingPumpkins_title: 'Smashing Pumpkins',
	SmashingPumpkins_description: 'School of Rock Seattle',

	Nirvana_title: 'Nirvana',
	Nirvana_description: 'School of Rock Seattle',

	HairMetal_title: 'Cheveux Métal',
	HairMetal_description: 'School of Rock Seattle',

	TalentShow2023_title: 'Spectacle de talents 2023',
	TalentShow2023_description: 'Seattle Salmon Bay K-8',

	Deftones_title: 'Deftones',
	Deftones_description: 'School of Rock Seattle',

	SeasonPreviewSpring2023_title: 'Aperçu de la saison printemps 2023',
	SeasonPreviewSpring2023_description: 'School of Rock Seattle',

	Ramones_title: 'Les Ramones',
	Ramones_description: 'School of Rock Seattle',

	Soundtrack_title: 'Spectacle de la bande originale',
	Soundtrack_description: 'School of Rock Seattle',

	PopPunkVsEmo_title: 'Pop Punk Vs. Emo',
	PopPunkVsEmo_description: 'School of Rock Seattle',

	_90sNostalgia_title: 'Nostalgie des années 90',
	_90sNostalgia_description: 'School of Rock Seattle',

	TalentShow2022_title: 'Spectacle de talents 2022',
	TalentShow2022_description: 'Seattle Salmon Bay K-8',

	// PRESS PAGE

	b_watch_here: 'Regardez ici',

	king_5_feature_title: 'Reportage Fulcrum / King 5',
	king_5_feature_description: 'Reportage télévisé de Seattle King 5 sponsorisé par Fulcrum',

	bateristland_title: 'Bateristland Featuring',
	bateristland_description: 'Interview sur la chaîne YouTube Bateristland',

	komo_news_title: 'Reportage Komo News',
	komo_news_description: 'Interview Seattle Refined',

	andrew_rooney_drums_title: 'Réaction d\'Andrew Rooney',
	andrew_rooney_drums_description: 'Andrew Rooney réagit à l\'interprétation de Tom Sawyer de Rush par Victoria',

	upper_lefters_interview_title: 'Interview Upper Lefters',
	upper_lefters_interview_description: 'Interview sur la chaîne YouTube Upper Lefters à propos de la carrière de Victoria et de ses projets futurs',

	the_eagle_969_title: '96.9 The Eagle Station de Radio de Classiques',
	the_eagle_969_description: 'Article de blog de 96.9 The Eagle Classic Hits sur la reprise de Rush par Victoria',

	fox_13_news_title: 'Fox 13 Seattle News avec',
	fox_13_news_description: 'Section True Northwest avec',

	the_daly_migs_show_interview_title: 'L\'interview du Daly Migs Show',
	the_daly_migs_show_interview_description: 'Interview sur le fait d\'être invité à rejoindre Godsmack sur scène',

	alizee_defan_07_02_2024_title: 'Entretien avec "Alizée Defan"',
	alizee_defan_07_02_2024_description: 'Interview exclusive',

	jaime_mendez_news_06_26_2024_title: 'Interview "Jaime Mendez Nouvelles"',
	jaime_mendez_news_06_26_2024_description: 'Nouvelles locales de Seattle en espagnol',

	bien_informado_03_22_2023_title: 'Article de "Bien Informado"',
	bien_informado_03_22_2023_description: 'Article du site d\'information argentin sur Victoria',

	wave_potter_reaction_01_30_2023_title: 'La réaction de Wave Potter',
	wave_potter_reaction_01_30_2023_description: 'Wave Potter réagit à la reprise de Victoria Lux Æterna de Metallica',

	// ABOUT PAGE

	b_back: 'Retourner',

	t_title: 'Victoria Acosta',
	t_pronouns: '(elle)',

	b_read_more: 'En savoir plus',
	b_read_less: 'Lire moins',
	b_stat_age: 'Âge',
	b_stat_shows: 'Concerts Live',
	b_stat_yrs: 'Ans de Batterie',
	b_stat_awards: 'Récompenses',

	t_about: `
Avec ses baguettes et le rythme dans l’âme, Victoria Acosta, âgée de {age} ans, est l’une des jeunes batteuses les plus prometteuses du moment. Née à El Paso, au Texas, élevée à Guadalajara, au Mexique, et désormais basée à Seattle, elle est reconnue pour son dévouement, son énergie et sa présence scénique.

Victoria a commencé la batterie à quatre ans et reçu sa première batterie le 13 septembre 2018. Elle s’est formée à l’académie Musicalerías de Guadalajara, puis a poursuivi ses études à Seattle. Après un cours d’essai à la School of Rock le 29 mai 2022, elle a sauté le programme Rock 101 pour intégrer directement le Performers Program. Depuis, elle s’est produite lors de {shows} concerts live.

Elle a enregistré des centaines de vidéos pour les réseaux sociaux et, le 13 juin 2024, a été invitée par le compositeur italien Alberto Rigonni comme batteuse sur Nemesis Call. Elle a reçu un endorsement de Soultone Cymbals le 12 septembre 2024 et a rejoint le roster d’artistes de Collision Drumsticks le 8 mars 2025.

En août 2025, Victoria a participé au Drum Fantasy Camp à Los Angeles, où elle a étudié avec Dave Weckl, Dennis Chambers, Peter Erskine et Gavin Harrison. Le même mois, elle a commencé à étudier avec le professeur de batterie Dave Stark, dont l’encadrement continue de développer sa technique, sa musicalité et son expression artistique.

Le 13 février 2026, Victoria est devenue artiste Paiste. Ce mois-là, elle a aussi participé au Rock and Roll Fantasy Camp, joué avec Nita Strauss, Stewart Copeland, Monte Pittman, Steve Stevens, Skunk Baxter et Leland Sklar, et s’est produite au Viper Room et au Whisky a Go Go. En 2026, elle a remporté la bourse Neil Peart Drum Set, attribuée par la Percussive Arts Society et Hudson.

En plus de la batterie, Victoria a commencé le violon en 4e année et a rejoint la World Youth Orchestra en 2024. Elle a partagé la scène avec Black Violin au Paramount Theatre et a débuté comme percussionniste avec le Ballard Civic Orchestra au Town Hall de Seattle pour une célébration de l’indépendance du Mexique.

Ses distinctions comprennent le Gold Prize et le Fantastic Technique Award du London Young Musician Contest 2022, ainsi que l’Annual Star Musician Award et l’Outstanding Drummer Special Award en 2023. Victoria s’entraîne chaque jour et repousse ses limites avec détermination et créativité.
	`,

	// PRESS PAGE

	t_footer: 'Tous droits réservés',

		// SOULTONE: 

		b_visit_artist_page: 'Visitez ma page d\'artiste'

}

export default fr;
